import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { GET_REVIEW_DATA } from '@custom/constant';
import { ReviewListArgs } from '@custom/Utils/constants/interfaces';

// Async thunk for fetching review list
export const fetchReviewList = createAsyncThunk(
  'customer/fetchReviewList',
  async ({ limit, pageNumber, search, status, fromDate, toDate }: ReviewListArgs, { rejectWithValue }) => {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    try {
      const response = await axios.post(GET_REVIEW_DATA, {
        limit,
        pageNumber,
        search,
        status,
        fromDate,
        toDate,
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export default fetchReviewList;
